import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import toast from "react-hot-toast";
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  LOGIN,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  REGISTER,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  PROFILE_DETAILS_SUCCESS,
  PROFILE_DETAILS_FAIL,
  PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS_SUCCESS,
  UPDATE_PROFILE_DETAILS_FAIL,
  EMAIL_VERIFY_SUCCESS,
  EMAIL_VERIFY_FAIL,
  EMAIL_VERIFY,
  UPLOAD,
  UPLOAD_SUCCESS,
  UPLOAD_FAIL,
} from "../actions/AuthActions";
import { API } from "../api";
function* login(action) {
  const { onError, ...otherData } = action.payload || {};
  try {
    const response = yield call(API.login, otherData);
    yield put({ type: LOGIN_SUCCESS, payload: response.data });
  } catch (e) {
    if (typeof onError === "function") {
      onError(e);
    }
    yield put({ type: LOGIN_FAIL, payload: { error: e } });
  }
}
function* register(action) {
  const { onError, ...otherData } = action.payload || {};
  try {
    const response = yield call(API.register, otherData);
    yield put({ type: REGISTER_SUCCESS, payload: response.data });
  } catch (e) {
    if (typeof onError === "function") {
      onError(e);
    }
    yield put({ type: REGISTER_FAIL, payload: { error: e } });
  }
}
function* forgotPassword(action) {
  const { onSuccess, onError, ...otherData } = action.payload || {};
  try {
    const response = yield call(API.forgot, otherData);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: FORGOT_PASSWORD_SUCCESS, payload: response.data });
  } catch (e) {
    if (typeof onError === "function") {
      onError(e);
    }
    yield put({ type: FORGOT_PASSWORD_FAIL, payload: { error: e } });
  }
}
function* resetPassword(action) {
  const { ...otherData } = action.payload;
  try {
    const response = yield call(API.passwordReset, otherData);
    yield put({ type: RESET_PASSWORD_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: RESET_PASSWORD_FAIL, payload: { error: e } });
  }
}

function* profileDetails(action) {
  try {
    const response = yield call(API.profileDetails, action.payload);
    yield put({ type: PROFILE_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: PROFILE_DETAILS_FAIL, payload: { error: error } });
  }
}
function* emailProfile(action) {
  try {
    const response = yield call(API.emailVerify, action.payload);
    yield put({ type: EMAIL_VERIFY_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: EMAIL_VERIFY_FAIL, payload: { error: error } });
  }
}

function* updateProfileDetails(action) {
  try {
    const { onSuccess, onError, ...otherPayload } = action.payload || {};
    const response = yield call(API.updateProfileDetails, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: UPDATE_PROFILE_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({ type: UPDATE_PROFILE_DETAILS_FAIL, payload: { error: error } });
  }
}
function* uploadImage(action) {
  try {
    const { onSuccess } = action
    const response = yield call(API.uploadImage, action.payload);
    if (typeof onSuccess === "function") {
      onSuccess(response.data.url);
    }
    yield put({ type: UPLOAD_SUCCESS, payload: response.data });
  } catch (error) {
    const message = error?.response?.data?.message || "Image upload failed.";
    toast.error(message);
    yield put({ type: UPLOAD_FAIL, payload: { error: error } });
  }
}

function* authSaga() {
  yield takeLeading(LOGIN, login);
  yield takeLeading(REGISTER, register);
  yield takeLeading(FORGOT_PASSWORD, forgotPassword);
  yield takeLatest(RESET_PASSWORD, resetPassword);
  yield takeLatest(PROFILE_DETAILS, profileDetails);
  yield takeLatest(EMAIL_VERIFY, emailProfile);
  yield takeLeading(UPDATE_PROFILE_DETAILS, updateProfileDetails);
  yield takeLatest(UPLOAD, uploadImage);
}
export default authSaga;
